<template>
  <div class="header">
    <div class="left">厦门市粮油销售管理系统</div>
    <div class="right">
      <span class="firstbox" @click="changePath('/maps')" :class="{active: 'maps' === this.$route.meta.title}">销售点</span>
      <span
        @click="changePath('/message/consult/index')"
        :class="{active: 'consult' === this.$route.meta.title}"
      >咨询服务</span>
      <span
        @click="changePath('/message/notice')"
        :class="{active: 'notice' === this.$route.meta.title}"
      >公告服务</span>
      <span v-if="!islogin">
        <i
          @click="changePath('/login/mobile')"
          :class="{active: 'login' === this.$route.meta.title}"
        >登录</i>
        &nbsp;|&nbsp;
        <i
          @click="changePath('/login/register')"
          :class="{active: 'register' === this.$route.meta.title}"
        >注册</i>
      </span>
      <span
        v-if="islogin"
        class="user"
        @click="changePath('/user/company')"
        @mouseover="showDialog"
        @mouseout="hideDialog"
        :class="{active: 'user' === this.$route.meta.title}"
      >
        <i>{{userMobile}}</i>
        <div class="userCenter" v-show="isShowDialog">
          <div class="dialogBox" v-if="role !== 'others'">
            <div class="triangle"></div>
            <div
              @click="changePath('/user/company')"
              @mouseover="changeColor(1)"
              :class="{color:isColor === 1}"
            >个人中心</div>
            <div
              @mouseover="changeColor(0)"
              :class="{color:isColor === 0}"
              @click.stop="logout"
            >退出登录</div>
          </div>
          <div class="dialogBox" style="height:30px;" v-if="role == 'others'">
            <div class="triangle"></div>
            <div
              @mouseover="changeColor(0)"
              :class="{color:isColor === 0}"
              @click.stop="logout"
            >退出登录</div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  data() {
    return {
      isShowDialog: false,
      isColor: "",
      islogin: false,
      userMobile: "",
      role: ""
    };
  },
  async mounted() {
    console.log('header userinfo',this.$store);
    if (this.$store.getters.userinfo.token) {
      this.islogin = true;
      this.userMobile = this.$store.getters.userinfo.mobile;
      // if(this.$store.getters.userinfo.status === -1) {
        let info = await store.dispatch("user/getInfo");
        this.role = this.$store.getters.userinfo.role;
      // }
    } else {
      this.islogin = false;
    }
  },
  methods: {
    changePath(path) {
      this.$router.push({
        path
      });
    },
    //鼠标悬停显示对话框
    showDialog() {
      this.isShowDialog = true;
    },
    hideDialog() {
      this.isShowDialog = false;
    },
    changeColor(index) {
      if (index === 1) {
        this.isColor = 1;
      } else if (index === 0) {
        this.isColor = 0;
      }
    },
    logout() {
      this.$confirm("是否退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await this.$store.dispatch("user/logout");
        this.$router.push(`/login/mobile`);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  height: 100px;
  background-image: url("../assets/img/006.jpg");
}
.left {
  font-size: 34px;
  line-height: 100px;
  padding-left: 60px;
  color: #fff;
}
.right {
  margin: 50px 129px 0 0;
  .firstbox {
    margin-left: 0;
  }
  cursor: pointer;
  span {
    display: inline-block;
    padding: 5px;
    margin-left: 70px;
    font-size: 20px;
  }
  span.active,
  i.active {
    color: #06386a;
    background-color: #fff;
  }
}
i {
  font-style: normal;
  cursor: pointer;
}
.user {
  position: relative;
  div {
    display: inline-block;
  }
  .userCenter {
    position: absolute;
    padding: 52px 20px 0;
    left: 0;
    width: 130px;
    height: 60px;
    z-index: 99;
    .dialogBox {
      width: 70%;
      display: inline-block;
      border: 1px solid #a0a0a0;
      height: 60px;
      border-radius: 5px;
      background-color: #fff;
      div {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #a7a7a7;
      }
      div:nth-child(2) {
        border-bottom: 1px solid #a0a0a0;
        line-height: 30px;
      }
      .triangle {
        position: absolute;
        top: 47px;
        left: 60px;
        width: 10px;
        height: 10px;
        border: 1px solid transparent;
        border-color: #a0a0a0 transparent transparent #a0a0a0;
        transform: rotate(45deg);
        background-color: #fff;
      }
      div.color {
        color: #53abf0;
      }
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 980px) {
  .header {
    display: block;
    .left {
      font-size: 28px;
      color: #fff;
      line-height: 0;
      padding: 30px 10px;
    }
    .right {
      margin: 0 0 0 10px;
      cursor: pointer;
      display: flex;
      span {
        display: inline-block;
        padding: 0;
        margin: 0;
        font-size: 14px;
        flex: 1;
      }
      span.active,
      i.active {
        color: #fff;
        background-color: rgba(0, 0, 0, 0);
        /*color: #06386a;*/
        /*background-color: #fff;*/
      }
    }
  }
}
</style>

